import { render } from "./ListiniCategoryPage.vue?vue&type=template&id=6f2e862a"
import script from "./ListiniCategoryPage.vue?vue&type=script&lang=js"
export * from "./ListiniCategoryPage.vue?vue&type=script&lang=js"

import "@/css/StockPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__